import { render } from "./BasePatientAccessInfoOffcanvas.vue?vue&type=template&id=3e572b78&scoped=true"
import script from "./BasePatientAccessInfoOffcanvas.vue?vue&type=script&lang=js"
export * from "./BasePatientAccessInfoOffcanvas.vue?vue&type=script&lang=js"

import "./BasePatientAccessInfoOffcanvas.vue?vue&type=style&index=0&id=3e572b78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e572b78"]])

export default __exports__